import { AppModule } from 'app/module';
import { JobsListItem } from 'module/jobsListItem/main';
import { Base64Link } from 'module/base64Link/main';
import Template from './template.hbs';
import './styles.scss';

export class CompanyJobsList extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            jobs: ['.m-jobsListItem'],
            jobsButton: '.m-companyJobsList__moreLink .m-base64Link',
        };
    }

    subs() {
        this.jobsItems = [];

        for (let i = 0; i < this.dom.jobs.length; i += 1) {
            const data = (this.props.jobs && {}.hasOwnProperty.call(this.props, i))
                ? this.props.jobs[i] : {};
            const job = new JobsListItem(this.dom.jobs[i]);
            job.updateProps(data);
            this.jobsItems.push(job);
        }

        if (this.dom.jobsButton) {
            this.jobsButton = new Base64Link(this.dom.jobsButton);
        }
    }

    subEvents() {
        for (let i = 0; i < this.jobsItems.length; i += 1) {
            const jobItem = this.jobsItems[i];

            jobItem.events.on(
                'changedLocation',
                (searchRequest) => this.events.emit('changedLocation', searchRequest.arguments[0]),
            );
        }
    }
}
